import React from 'react';
import TranslationsData from './data/translationsData';
function Translations() {
  return (
    <div>
      <h2>Translations of Writings by CBB</h2>
      <TranslationsData/>
    </div>
  );
}

export default Translations;
